import Link from "next/link";
import { use, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PricingTab from "./PricingTab/PricingTab";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import styles from "./SelectPlan.module.css";
//import redux dispatch
import { useDispatch, useSelector } from "react-redux";
//import store actions
import * as actions from "../../../../MainWebsiteComponent/store/actions";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={1}>
          {/* p tag has issues wrapping div tags with NextJS */}
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SelectPlan = () => {
  const dispatch = useDispatch();

  const [tabValue, setValue] = useState(useSelector((state) => state.paymentPeriod));
  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(actions.setPaymentPeriod(newValue));
  };

  return (
    <div>
      
        <div>
          <div className="TabContainer">
            <div className="TabHeader">
              <div className="FilterContainer">
                <h4 style={{fontSize: '24px', fontWeight: '600'}}>Select a plan</h4>
              </div>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label={<p>Annual (Save 20%)</p>} {...a11yProps(0)} />
                <Tab label={<p>Monthly</p>} {...a11yProps(1)} />
              </Tabs>
            </div>

            {/* <div className={styles.ChipContainer}>
              {chipData.map((data) => {
                let icon;
                return (
                  <div key={data.key} className={styles.chipBox}>
                    <Chip
                      icon={icon}
                      label={data.label}
                      onDelete={
                        data.label === "React" ? undefined : handleDelete(data)
                      }
                    />
                  </div>
                );
              })}
            </div> */}

            <TabPanel value={tabValue} index={0}>
              <PricingTab pricing={pricing} />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <PricingTab pricing={pricingmonthly} />
            </TabPanel>
          </div>
        </div>
            <div>
              <Link href="/pricing" className={styles.pricingLink}>View complete feature list <LaunchRoundedIcon fontSize="small"/></Link>
            </div>
    </div>
  );
};

export default SelectPlan;

  const pricing = [
    {
      packageLabel: "Starter",
      mostPopular: false,
      price: 29,
      cutprice: 34.8,
      packagePlan: "$348 billed annually",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
    {
      packageLabel: "Pro",
      mostPopular: true,
      price: 69,
      cutprice: 82.8,
      packagePlan: "$828 billed annually",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
    {
      packageLabel: "Enterprise",
      mostPopular: false,
      price: 89,
      cutprice: 106.8,
      packagePlan: "$1068 billed annually",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
  ];

  const pricingmonthly = [
    {
      packageLabel: "Starter",
      mostPopular: false,
      price: 34.80,
      // cutprice: 34.8,
      packagePlan: "Pay annually & save $69.60",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
    {
      packageLabel: "Pro",
      mostPopular: true,
      price: 82.80,
      // cutprice: 82.8,
      packagePlan: "Pay annually & save $165.60",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
    {
      packageLabel: "Enterprise",
      mostPopular: false,
      price: 106.80,
      // cutprice: 106.8,
      packagePlan: "Pay annually & save $213.60",
      includes: [
        {
          strong: '10',
          details: "course",
          tooltip: "10 course",
        },
        {
          strong : '100',
          details: "students",
          tooltip: "100 students",
        },
        {
          strong : '6%',
          details: "platform cost",
          tooltip: "6% platform cost",
        },
        {
          details: 'Publish courses',
          tooltip: 'Publish courses',
        },
        {
          details: 'Manage students',
          tooltip: 'Manage students',
        },
        {
          details: 'Manage team members',
          tooltip: 'Manage team members',
        }
        
      ],
    },
  ];
